var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_912e2fe6"]},_vm.$listeners),[_c('cube-button',{class:["mt10"],attrs:{"icon":"like","tip":"辅助文案","primary":"","outline":""}},[_vm._v("主要文案")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }